import fp from 'lodash/fp';
import trimStart from 'lodash/trimStart';
import moment from 'moment';

export const bem = (block, element, modifier) =>
	block &&
	`${block}${element ? '__' + element : ''}${
		modifier ? '--' + modifier : ''
	}`;

export const compare = (a, b) => {
	if (a < b) return -1;
	else if (a > b) return 1;
	else return 0;
};
export const compareGraded = (...pairs) => {
	return (
		compare(pairs[0][0], pairs[0][1]) ||
		(pairs.length > 1 ? compareGraded(...pairs.slice(1)) : 0)
	);
};
export const comparePropertiesGraded = (object1, object2, ...properties) => {
	return compareGraded(
		...properties.map(property => [object1[property], object2[property]]),
	);
};

export const convertFromIsoTime = datetime => {
	// Accepts ISO 8601 datetime (e.g. 2018-12-03T17:50:40+00:00),
	// returns human readable "friendly" format (e.g. 2018-12-03 17:50:40).
	return `${moment(datetime).format('DD/MM/YYYY HH:mm:ss')}`;
};

export const convertToIsoTime = datetime => {
	// Accepts human readable "friendly" format (e.g. 2018-12-03 17:50:40),
	// returns ISO 8601 datetime (e.g. 2018-12-03T17:50:40+00:00).
	return `${moment(datetime, 'DD/MM/YYYY HH:mm:ss').format(
		'YYYY-MM-DD[T]HH:mm:ss',
	)}`;
};

export const sleep = time => new Promise(resolve => setTimeout(resolve, time));

export const noop = () => Promise.resolve();

export const base64EncodeUint8Array = unit8Array =>
	fp.compose(
		btoa,
		fp.join(''),
		fp.map(char => String.fromCharCode(char)),
	)(unit8Array);

export const uint8ArrayDecodeBase64 = base64 =>
	new Uint8Array(
		fp.compose(
			fp.map(string => string.charCodeAt(0)),
			fp.split(''),
			atob,
		)(base64),
	);

export const base64EncodeArrayBuffer = arrayBuffer =>
	base64EncodeUint8Array(new Uint8Array(arrayBuffer));

export const arrayBufferDecodeBase64 = base64 =>
	uint8ArrayDecodeBase64(base64).buffer;

export const getImageData = data =>
	process.env.REACT_APP_WS_MESSAGE_FORMAT === 'json' // else 'msgpack'
		? data instanceof ArrayBuffer
			? base64EncodeArrayBuffer(data)
			: typeof data === 'string'
			? data
			: undefined
		: data instanceof ArrayBuffer
		? data
		: typeof data === 'string'
		? arrayBufferDecodeBase64(data)
		: undefined;

export const formatImageDataBase64Uri = (mimeType, data) =>
	`data:${mimeType};base64,${data}`;

export const parseQueryString = string =>
	fp.compose(
		JSON.parse,
		JSON.stringify,
		fp.reduce((acc, part) => {
			const [name, value] = part.split('=');
			acc[name] = decodeURIComponent(value || '');
			return acc;
		}, {}),
		str => (str ? str.split('&') : []),
		fp.replace('?', ''),
	)(string);

export const getQueryParams = string => {
	const {
		filter,
		view = 'list',
		grouping = 'all',
		search = '',
	} = parseQueryString(string);
	const filters = filter ? filter.split(',') : [];
	return {
		filters,
		view,
		grouping,
		search,
	};
};

export const jsonToQueryString = obj => {
	const pairs = [];
	obj &&
		Object.keys(obj).forEach(key => {
			if (obj[key]) {
				const value = encodeURIComponent(obj[key]);
				value && pairs.push(`${key}=${value}`);
			}
		});

	return pairs.length ? `?${pairs.join('&')}` : '';
};

export const referenceMap = (array, targetkey) =>
	Array.isArray(array)
		? array.reduce((acc, item) => {
				acc[item[targetkey]] = item;
				return acc;
		  }, {})
		: {};

export const sortSchedules = fp.sortBy(item => {
	return fp.compose(
		str => trimStart(str, '- '),
		fp.replace(item.scheduleId, ''),
	)(item.name);
});

export default null;



// WEBPACK FOOTER //
// ./src/utils/helpers.js